export enum AllowanceStatus {
  NOT_AVAILABLE = 'NOT_AN_ERC20_TOKEN',
  NOT_ALLOWED = 'ALLOWANCE_IS_EQUAL_TO_ZERO',
  LIMITED = 'ALLOWANCE_IS_LOWER_THAN_USER_BALANCE',
  INFINITE = 'ALLOWANCE_IS_HIGHER_THAN_USER_BALANCE',
}
